export default __webpack_public_path__ + "static/media/info.74982fb8.svg";